import { ADDONS, PRICE_MODEL } from '#common/constants/addons';

import icon from './assets/SWMShipping.jpg';

import type { Addon } from '../types';

function Description() {
  return (
    <>
      <div>
        The <b>SWM</b> (S)mall (W)arehouse (M)anagement <b>Shipping Module</b> enhances the SWM platform by providing below features:
      </div>
      <br />
      <div>
        For admins:
        <ul>
          <li>The admins can integrate <b>Shipping Methods</b> from <b>UPS</b>.</li>
          <li>The admins can purchase and print shipping labels per different shipping methods.</li>
          <li>The shipping charges will be deducted from the customer{'\''}s UPS account.</li>
        </ul>
      </div>
    </>
  );
}

const addon: Addon = {
  apply: () => {

  },
  info: {
    id: ADDONS.SHIPPING,
    available: true,
    name: 'SWM Shipping',
    version: '1.0',
    icon,
    descriptionText: 'SWM Shipping module opens up the ability to purchase and print shipping labels by integrating with UPS.',
    descriptionComponent: <Description />,
    priceModel: PRICE_MODEL.ONE_TIME_PURCHASE,
    price: 199.99,
  },
};

export { default as ShippingComponent } from './ShippingComponent';

export default addon;
